import api from './api';

// Get all tags
export const getTags = async (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.categoryId) {
        queryParams.append('categoryId', params.categoryId);
    }

    if (params.subcategoryId) {
        queryParams.append('subcategoryId', params.subcategoryId);
    }

    const url = queryParams.toString() ? `/tags?${queryParams.toString()}` : '/tags';
    const response = await api.get(url);
    return response.data;
};

// Get tag by ID
export const getTag = async (id) => {
    const response = await api.get(`/tags/${id}`);
    return response.data;
};

// Create tag (Super Admin only)
export const createTag = async (tagData) => {
    const response = await api.post('/tags', tagData);
    return response.data;
};

// Update tag (Super Admin only)
export const updateTag = async (id, tagData) => {
    const response = await api.put(`/tags/${id}`, tagData);
    return response.data;
};

// Delete tag (Super Admin only)
export const deleteTag = async (id) => {
    const response = await api.delete(`/tags/${id}`);
    return response.data;
};

// Bulk create tags from CSV (Super Admin only)
export const bulkCreateTags = async (csvFile) => {
    const formData = new FormData();
    formData.append('csv', csvFile);

    const response = await api.post('/tags/bulk', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return response.data;
};

// Bulk delete tags (Super Admin only)
export const bulkDeleteTags = async (tagIds) => {
    const response = await api.delete('/tags/bulk', {
        data: { ids: tagIds }
    });
    return response.data;
};